import * as Sentry from "@sentry/react";

export const errorLog = (error: any, message: string = "") => {
  console.error(message, error);
  Sentry?.captureException?.(error, { data: message });
};
